import { render, staticRenderFns } from "./PerfectInfoDialog.vue?vue&type=template&id=117f9196&scoped=true"
import script from "./PerfectInfoDialog.vue?vue&type=script&lang=js"
export * from "./PerfectInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./PerfectInfoDialog.vue?vue&type=style&index=0&id=117f9196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f9196",
  null
  
)

export default component.exports